/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".top-bar[_ngcontent-%COMP%]{background:linear-gradient(45deg,#004e9b,#002f6d);padding:15px 10px;color:#fff}.top-bar[_ngcontent-%COMP%]   .back-image-wrapper[_ngcontent-%COMP%]{width:26px;height:26px;border-radius:50%;background-color:#fff}@media (min-width:1200px){[_nghost-%COMP%]     app-home-estimator .wrapper{margin-top:30px}}"];
export { styles as styles };
